var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",staticStyle:{"padding":"16px","margin-bottom":"24px"}},[_c('p',[_vm._v(_vm._s(_vm.$t('dashboard.new_season_hint')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }